import { BrowserRouter, Route, Router, Routes } from "react-router-dom";
import NavBarComponent from "./Components/NavbarComponent";
import Home from "./Pages/Home";
import Policy from "./Pages/Policy";

function App(): JSX.Element {
  return (
    <BrowserRouter>
      <NavBarComponent />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/policy" element={<Policy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
